<template>
    <i :class="'fa '+name" aria-hidden="true"></i>
</template>
<script type="text/javascript">
    export default {
        name: 'icon',
        props: ['name'],
        mounted(){
        }
    }
</script>


// WEBPACK FOOTER //
// icon.vue?2877e62c